import { render, staticRenderFns } from "./DashboardWidget.vue?vue&type=template&id=f17b6dc8&scoped=true"
import script from "./DashboardWidget.vue?vue&type=script&lang=js"
export * from "./DashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidget.vue?vue&type=style&index=0&id=f17b6dc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17b6dc8",
  null
  
)

export default component.exports